import React from 'react';
import styles from './kpi.module.css';
import { helpIconKpiTitles, currancyInRupees } from 'Samarth Module/pages/quickComm/QuickCommStatic.js';
import { IoMdInformationCircleOutline } from 'react-icons/io';

export default function KPI({ kpiCardData, sideTab }) {

    return (
        <>
            {kpiCardData.map((item, index) => (
                <div key={index} className={styles.kpiCard} style={{ width: `${100 / kpiCardData.length}%` }}>
                    <div className={styles.kpiImg}>
                        <img src={item.img} alt={'img'} />
                    </div>
                    <div style={{ width: '100%' }}>
                        <p className={styles.title}>
                            {item.title}{helpIconKpiTitles.includes(item.title) && <IoMdInformationCircleOutline />}
                        </p>
                        <div className={styles.kpiValueContainer}>
                            {item["value"].map((val, idx) => (
                                <div style={{ display: 'flex', alignItems: 'center' }} key={idx}>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <div key={idx + val}>
                                            {item.currency && <span className={styles.kpiCurrency}>{item.currency}&nbsp;</span>}
                                            <span className={styles.kpiValue}>{item.currency ? currancyInRupees(val) : sideTab !== 'Tonnes' ? item.title !== 'Customer Daily on Hand(DoH)' ? val.toFixed(0) : val.toFixed(2) : val}</span>
                                            {item.unit && <span className={styles.kpiUnits}>&nbsp;{item.unit || ''}</span>}
                                            {item['units'] && item['units'][idx] &&
                                                <span className={styles.kpiUnits}>&nbsp;{item['units'][idx]}</span>
                                            }
                                        </div>
                                        {item["valueRange"] &&
                                            <div key={item["valueRange"][idx]} className={styles.valueRangeItem}>
                                                {item["valueRange"][idx]}
                                            </div>
                                        }
                                    </div>
                                    {item["percentage_as_per_value"]?.length &&
                                        <div>
                                            <div className={styles.rightSideValue}>
                                                <span>{item["percentage_as_per_value"][idx]}</span>
                                            </div>
                                        </div>
                                    }
                                    {item["value"].length - 1 !== idx &&
                                        <div display='flex' alignItems='center'>
                                            <span className={styles.pole}>&nbsp;|&nbsp;</span>
                                        </div>
                                    }
                                </div>
                            ))}
                            {item.rightSideValue &&
                                <div className={styles.rightSideValue}>
                                    <span>{item.rightSideValue}</span>
                                </div>
                            }
                        </div>
                        {item.title1 &&
                            <>
                                <p className={styles.title}>{item.title1}</p>
                                <div className={styles.kpiValueContainer}>
                                    {item["value1"].map((val, idx) => (
                                        <div style={{ display: 'flex', alignItems: 'center' }} key={idx}>
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div key={idx + val}>
                                                    <span className={styles.kpiValue}>{val.toFixed(0)}</span>
                                                </div>
                                            </div>
                                            {item["value1"].length - 1 !== idx &&
                                                <div display='flex' alignItems='center'>
                                                    <span className={styles.pole}>&nbsp;|&nbsp;</span>
                                                </div>
                                            }
                                        </div>
                                    ))}
                                    {item["rightSideValue1"] &&
                                        <div className={styles.rightSideValue}>
                                            <span>{item.rightSideValue1}</span>
                                        </div>
                                    }
                                </div>
                            </>
                        }
                    </div>
                </div>
            ))}
        </>
    );
};